import React from 'react';
import styles from './CloseBtn.module.css';

export default function CloseBtn({ handleClick }) {
  return (
    <div className={styles.close_btn} onClick={() => handleClick(false)}>
      <div className={styles.line + ' ' + styles.line_1}></div>
      <div className={styles.line + ' ' + styles.line_2}></div>
    </div>
  );
}
